// A persistent banner across the top of the main area, on every page except the mentioned
// thread itself, until the mention is read (or dismissed for the session).
import { Link } from 'react-router';
import { conversationTitle, relativeTime } from '../lib/format.js';
import { useMentions } from '../state/mentions.js';

export function MentionBanner(props: {
  userId: string | null | undefined;
  projectId: string | undefined;
  openConversationId: string | undefined;
}): React.ReactElement | null {
  const { mentions, count, dismissed, dismiss } = useMentions(props.userId, props.openConversationId);
  const visible = mentions.filter((m) => m.conversationId !== props.openConversationId);
  if (visible.length === 0) return null;
  if (dismissed && visible[0] && dismissed.mentionedAt >= visible[0].mentionedAt) return null;
  const first = visible[0]!;
  const who = first.byName ?? 'Someone';
  const where = first.conversationTitle ? conversationTitle(first.conversationTitle) : first.projectName;
  return (
    <div className="mention-banner" role="status">
      <div className="mention-banner-main">
        <span>
          <strong>{who}</strong> mentioned you in {where}: {first.excerpt}
        </span>
        {visible.length > 1 ? <span className="mention-banner-more">{`and ${visible.length - 1} more`}</span> : null}
      </div>
      <span className="mention-banner-actions">
        <span className="muted tiny">{relativeTime(first.mentionedAt)}</span>
        <Link
          className="link-btn"
          to={`/p/${first.projectId}/c/${first.conversationId}`}
          onClick={() => dismiss()}
        >
          Open
        </Link>
        <button type="button" className="link-btn" onClick={() => dismiss()}>
          Dismiss
        </button>
        <span className="mention-banner-count" aria-label={`${count} unread mentions`}>
          {count}
        </span>
      </span>
    </div>
  );
}
